import {
  Box,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  Autocomplete,
  Grid,
  Typography,
} from "@mui/material";
import { RADIO_BOOLEAN, SignupFormResp } from "../data/useSignupForm";
import { SignupFormValidatorResp } from "../data/useSignupFormValidator";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PersonContactForm from "./PersonContactForm";
import { InfoTooltip } from "../styles/styledTooltip";
import { WhiteTextField } from "../styles/styledTextField";
import { useState } from "react";

interface SubmitterFormProps {
  signupdata: SignupFormResp;
  validator: SignupFormValidatorResp;
}

export default function SubmitterForm(props: SubmitterFormProps) {
  const [selectedRole, setSelectedRole] = useState<string>("");
  const isSfoLeader = props.signupdata.departmentLeaderIsSubmitter;
  const isSkole = props.signupdata.entityData.entityType === "SKOLE";
  const isBarnehage = props.signupdata.entityData.entityType === "BARNEHAGE";
  const barnehageRollerOptionss = [
    "Barnehagestyrer",
    "Pedagogisk leder",
    "Ansatt i barnehage",
    "Kokk/matansvarlig",
    "Annet",
  ];

  return (
    <>
      <PersonContactForm
        signupdata={props.signupdata}
        key="innsender"
        entityType="submitter"
        title="Hvem er du?"
        stepValidation={props.validator.validStep4a}
      />

      {isSkole && (
        <FormControl
          sx={{ marginTop: "25px" }}
          error={
            props.validator.validStep4b.dirtyStep &&
            props.validator.validStep4b.validStepDetails[
              "departmentLeaderIsSubmitter"
            ]
              ? true
              : false
          }
          required
        >
          <FormLabel id="sfo-lead-input-label">Er du SFO-leder?</FormLabel>
          <RadioGroup
            row
            value={isSfoLeader}
            onChange={(event) => {
              props.signupdata.setDepartmentLeaderIsSubmitter(
                event.target.value,
              );
            }}
            aria-labelledby="sfo-lead-input-label"
            name="row-radio-buttons-group"
          >
            <FormControlLabel
              sx={{ marginLeft: "5px", marginTop: "5px" }}
              value={RADIO_BOOLEAN.TRUE}
              control={<Radio sx={{ marginLeft: "5px" }} />}
              label="Ja"
            />
            <FormControlLabel
              sx={{ marginTop: "5px" }}
              value={RADIO_BOOLEAN.FALSE}
              control={<Radio sx={{ marginLeft: "15px" }} />}
              label="Nei"
            />
          </RadioGroup>
          <FormHelperText>
            {props.validator.validStep4b.dirtyStep
              ? props.validator.validStep4b.validStepDetails[
                  "departmentLeaderIsSubmitter"
                ]
              : ""}
          </FormHelperText>
        </FormControl>
      )}

      {isBarnehage && (
        <>
          <Typography
            component="h2"
            sx={{ fontWeight: "bold", marginTop: "25px", width: "100%" }}
          >
            Hva er din rolle?
            <InfoTooltip
              title="Hvorfor spør vi om dette?"
              description="Påmeldingen må godkjennes av barnehagestyrer. Dersom du selv ikke er styrer i barnehagen kan du legge inn kontaktinfo til barnehagestyrer i neste steg."
            >
              <div
                style={{
                  float: "right",
                  padding: "0px 0px 0px 10px",
                  cursor: "pointer",
                }}
              >
                <InfoOutlinedIcon />
              </div>
            </InfoTooltip>
          </Typography>

          <Grid container spacing={3} sx={{ marginTop: 0 }}>
            <Grid item xs={12}>
              <Autocomplete
                disablePortal
                value={selectedRole}
                id="role-selector"
                options={barnehageRollerOptionss}
                renderInput={(params) => (
                  <WhiteTextField
                    {...params}
                    label="Din rolle"
                    variant="filled"
                    required
                    error={
                      props.validator.validStep4b.dirtyStep &&
                      props.validator.validStep4b.validStepDetails[
                        "submitterRole"
                      ]
                        ? true
                        : false
                    }
                    helperText={
                      props.validator.validStep4b.dirtyStep
                        ? props.validator.validStep4b.validStepDetails[
                            "submitterRole"
                          ]
                        : null
                    }
                  />
                )}
                onChange={(e: any, newValue: string | null) => {
                  setSelectedRole(newValue || "");
                  props.signupdata.setSubmitter({
                    ...props.signupdata.submitter,
                    role: newValue || "",
                  });
                  props.signupdata.setLeaderIsSubmitter(
                    newValue === "Barnehagestyrer",
                  );
                }}
              />
            </Grid>

            {props.signupdata.submitter.role === "Annet" && (
              <Grid item xs={12}>
                <WhiteTextField
                  required
                  label="Annen rolle (spesifiser)"
                  variant="filled"
                  fullWidth
                  error={
                    props.validator.validStep4b.dirtyStep &&
                    props.validator.validStep4b.validStepDetails["roleOther"]
                      ? true
                      : false
                  }
                  helperText={
                    props.validator.validStep4b.dirtyStep
                      ? props.validator.validStep4b.validStepDetails[
                          "roleOther"
                        ]
                      : null
                  }
                  value={props.signupdata.submitter.roleOther}
                  onChange={(e) => {
                    props.signupdata.setSubmitter({
                      ...props.signupdata.submitter,
                      roleOther: e.target.value,
                    });
                  }}
                />
              </Grid>
            )}
          </Grid>
        </>
      )}

      {isSkole && isSfoLeader === "no" && (
        <Box sx={{ marginTop: "45px", marginBottom: "25px" }}>
          <PersonContactForm
            signupdata={props.signupdata}
            key="departmentleader"
            entityType="departmentleader"
            title="SFO-leder"
            subHeading
            stepValidation={props.validator.validStep4b}
          />
        </Box>
      )}
    </>
  );
}
